import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { AudioService } from 'src/app/services/Modules/audio.service';
import { TranscriptionDetailService } from '../transcription-detail/transcription-detail.service';
import { NoteCommentsService } from './note-comments/note-comments.service';
import * as global from '../global'
import { SidebarChargesComponent } from 'src/app/components/sidebar-addCharges/sidebar-charges/sidebar-charges.component';
import { BehaviorSubject } from 'rxjs';
import { NoteAddChargeComponent } from './note-addCharge/note-add-charge/note-add-charge.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ActivatedRoute } from '@angular/router';
import { NoteAddChargeService } from './note-addCharge/note-add-charge.service';
import { WoundCareWidgetService } from './wound-care-widget/wound-care-widget.service';
import { WatchHelpVideoDialog } from '../drive/watch-help-video-dialog.component';
import { WoundCareWidgetComponent } from './wound-care-widget/wound-care-widget.component';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { WoundDermSidebarComponent } from './wound-derm-sidebar/wound-derm-sidebar.component';
import _ from 'lodash';
@Component({
  selector: 'app-note-sidebar',
  templateUrl: './note-sidebar.component.html',
  styleUrls: ['./note-sidebar.component.css']
})
export class NoteSidebarComponent implements OnInit, OnChanges {
  @Input() censusId: String;
  @Input() patientId: String;
  @Input() noteId: String;
  @Input() note: any;
  @Input() relationship: any;
  @Input() addendum_counts: any;
  @Input() audioId: string;
  @Input() noteEditorIcds: any[] = [];
  @Input() noteEditorCpts: any[] = [];
  @Input() emCodeEditorCpts: any[] = [];
  @Input() signedNotesStatus: any = false;
  @Input() companySubmitMipsStatus: any = false;
  @Input() carryChargeStatus: any = false;
  @Input() shouldNoteTimeLogs: boolean = false;
  @Output() submitButonClicked = new EventEmitter<any>();

  @Input() telemedPhrase: any = false;
  currentUser: any;

  global: any = global;
  @Output() onTemplateSelect: EventEmitter<any> = new EventEmitter()
  @Output() closeSidebar: EventEmitter<Boolean> = new EventEmitter()
  @Output("onAddendumClick") onAddendumClick: EventEmitter<any> = new EventEmitter()
  @Output() onChargeChange: EventEmitter<any> = new EventEmitter();
  @Output() onChargeAndICDChange: EventEmitter<any> = new EventEmitter();
  @Output() onICDsSave: EventEmitter<any> = new EventEmitter();
  @Output() onHtmlTextChanges: EventEmitter<any> = new EventEmitter();
  @Output() onNoteEdiorCptsChange: EventEmitter<any> = new EventEmitter();
  @Output() onNoteEdiorIcdsChange: EventEmitter<any> = new EventEmitter();
  @Output() woundDetailsChange: EventEmitter<any> = new EventEmitter();
  @Output() insertPhraseText: EventEmitter<any> = new EventEmitter();


  selectedTabIndex = 0;
  tabIndexAutoInitialized = false;
  fromSideBar: boolean = true;
  @ViewChild(NoteAddChargeComponent) noteAddChargeComponent: NoteAddChargeComponent;
  @ViewChild(SidebarChargesComponent) sidebarChargesComponent: SidebarChargesComponent;
  @ViewChild(WoundCareWidgetComponent) skinwoundCareComponent: WoundCareWidgetComponent;
  @ViewChild(WoundDermSidebarComponent) woundDermSidebar: WoundDermSidebarComponent;
  tabs: any = [
    { name: 'Wound/DERM', is_active: false },
    { name: 'Charge Capture', is_active: true },
    { name: 'Patient Details', is_active: false },
    { name: 'Phrases', is_active: false },
    { name: 'Census Comments', is_active: false },
    { name: 'History', is_active: false },
    { name: 'Communication', is_active: false },
    { name: 'Addendums', is_active: false },
    { name: 'Therapy', is_active: false }, 
    { name: 'Note Time Logs', is_active: false }, 
    // { name: 'Transcript', is_active: false },
    // { name: 'Chunks', is_active: false },
  ];
  should_show_therapy_tab:boolean=false
  shouldShowPdfScrubber: boolean = false;
  updatedArray: any = [];
  tab: any;
  tabConditions: any = {};
  currentUserChargeStatus: Boolean;
  roundingSheetId;
  patient_id;
  isChargeTabActive: boolean = false;
  woundStateCounts = {
    activeCount: 0,
    remissionCount: 0,
    amputatedCount: 0,
    archiveCount: 0
  }
  allDataLoaded: Boolean = false;
  patient_object: any;
  isDermAllowed: boolean = false;
  dermTabIndex: number = -1;
  constructor(
    private _authService: AuthService,
    private noteCommentsService: NoteCommentsService,
    private _activatedRoute: ActivatedRoute,
    private _noteAddChargeService: NoteAddChargeService,
    private _woundCareService: WoundCareWidgetService,
    private dialog: MatDialog,
    private companyService: CompanyService,
  ) {
    const currentUser = this._authService.currentUser;
    if (currentUser) {
      // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.currentUser = currentUser;
      this.currentUserChargeStatus = this.currentUser.charge_status;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.tabIndexAutoInitialized) {

      const noteChanges = changes['note'];
      if (!noteChanges) return;
      let curNote = JSON.stringify(noteChanges.currentValue);
      let prevNote = JSON.stringify(noteChanges.previousValue);
      const note = noteChanges.currentValue;
      if (curNote !== prevNote && note?.rounding_sheet_id) {
        this.selectedTabIndex = 0;
        this.tabIndexAutoInitialized = true;
      }
    }
  }
  async getTherapyTabStatus() {
    [this.should_show_therapy_tab, this.shouldShowPdfScrubber, this.isDermAllowed] = await this.companyService.checkCompanyPermission(["should_show_therapy_tab", "should_show_pdf_scrubber_tab", "allow_derm"], this.currentUser.company_id);
  }
  async ngOnInit() {
    await this.getTherapyTabStatus();
    if (!this.patientId) {
      this.patient_id = this.note?.patient?._id;
      this.patient_object=this.note?.patient;
      this.patientId = this.patient_id;
    }
    await this.getwoundCountState();
    if (!this.censusId) {
      this.roundingSheetId = this.note?.rounding_sheet_id;
      this.censusId = this.roundingSheetId;
    }
    await this.initTabs();
    this.tabConditions = {
      "Wound/DERM": this.currentUser.company_type !== 'Wound',
      "Census Comments": !(this.censusId || this.roundingSheetId),
      "Communication": !this.noteId,
      "Addendums": this.addendum_counts?.total <= 0,
      "Charge Capture": !(this.note?.facility?.enabled_charge_capture != false && this.currentUserChargeStatus != false && (this.censusId || this.roundingSheetId)),
      "Phrases": this.currentUser.user_type === global.USER_TYPE.BUSINESS_OFFICER,
      "Note Time Logs" : !this.shouldNoteTimeLogs,
      "Derm": this.dermTabIndex !== -1,
    };
    if (this.updatedArray.length == 0) {
      console.log('first time', this.updatedArray.length);
      this.updatedArray = this.tabs;
    }

    this.applyTabConditions();
    // Census Comments *ngIf="censusId && patientId
    // if (this.tabConditions['Census Comments']) {
    //   this.filtertabs("Census Comments");
    // }
    // label="Comments" *ngIf="noteId"
    // if (this.tabConditions['Comments']) {
    //   this.filtertabs("Comments");
    // }
    // label="Addendums" *ngIf="addendum_counts?.total > 0"
    // if (this.tabConditions['Addendums']) {
    //   this.filtertabs("Addendums");
    // }
    // label="Charge Capture" *ngIf="note?.facility.enabled_charge_capture"
    console.log('this.note?.facility?.enabled_charge_capture', this.note?.facility?.enabled_charge_capture, 'this.currentUserChargeStatus', this.currentUserChargeStatus, 'this.censusId', this.censusId, 'this.roundingSheetId', this.roundingSheetId);
    // if (this.tabConditions['Charge Capture']) {
    //   this.filtertabs("Charge Capture");
    // }
    // if (this.tabConditions['Skin/Wound']) {
    //   this.filtertabs("Skin/Wound");
    // }
    this.updatedArray.forEach(element => {
      element.is_active = false;
    });

    if (this._activatedRoute.snapshot.paramMap.get('isChargeTabActive')) {
      const index = this.updatedArray.findIndex(item => item.name === "Charge Capture");
      if (index !== -1) {
        this.tab = this.updatedArray[index].name;
        this.updatedArray[index].is_active = true;
      }
    }
    else {
      this.tab = this.updatedArray[0].name;
      this.updatedArray[0].is_active = true;
    }
    this.allDataLoaded = true;
    //move therapy tab to last index
    for(var x in this.updatedArray) this.updatedArray[x].name == "Therapy" ? this.updatedArray.push( this.updatedArray.splice(x,1)[0] ) : 0;

    console.log('updatedArray',this.updatedArray);
    
  }
  ngOnDestroy(): void {
    this._noteAddChargeService.setisCPT(false);
    this._noteAddChargeService.setisICD(false);
  }
  initTabs(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.noteCommentsService.getTabSettings().subscribe(data => {
        // @ts-ignore
        const { data: tabData } = data;
        if (tabData.length > 0) {
          let tabsArray = [...this.tabs];
          this.updatedArray = [...tabData];
          this.dermTabIndex = this.updatedArray.findIndex(item => item.name === "Derm");

          this.updatedArray.forEach(item => {
            if (item.name === "Skin/Wound") {
              item.name = "Wound/DERM";
            }
          });
          this.updatedArray = this.updatedArray.filter((item, index, self) =>
            index === self.findIndex(t => t.name === item.name)
          );

          tabsArray.forEach(tab => {
            if (!this.updatedArray.some(updatedTab => updatedTab.name === tab.name)) {
              this.updatedArray.push(tab);
            }
          });
        }
        resolve();
      }, error => {
        reject('Error: ' + error.toString());
      });
    });
  }
  applyTabConditions() {
    for (const key in this.tabConditions) {
      if (this.tabConditions[key]) {
        this.filtertabs(key);
      }
    }
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.updatedArray, event.previousIndex, event.currentIndex);
    const updatedTabs = _.cloneDeep(this.updatedArray);
    const woundDermTabIndex = updatedTabs.findIndex(tab => tab.name === 'Wound/DERM');
    if (woundDermTabIndex !== -1) updatedTabs[woundDermTabIndex].name = 'Skin/Wound';
    if (this.dermTabIndex !== -1) updatedTabs.splice(this.dermTabIndex, 0, { name: 'Derm', is_active: false });
    this.noteCommentsService.addTabSettings(updatedTabs).subscribe((Response: any) => {
      if (Response.status == 200) {
        console.log('added settings');
      }
    });

  }
  filtertabs(tabName: String) {
    this.updatedArray = this.updatedArray.filter(t => t.name !== tabName);
    //Filter charge capture for CNP ROLE//
    if(this.currentUser?.additional_user_role == global.USER_TYPE.CNP) {
      this.updatedArray = this.updatedArray.filter(t => t.name != 'Charge Capture');
    }
  }

  public tabChange(tab, index) {
    this.tab = tab.name;
    this.updatedArray.forEach((element, i) => {
      if (index !== i)
        element.is_active = false
    });
    tab.is_active = true;
  }

  handleAddendumClick(e) {
    this.onAddendumClick.emit(e);
  }

  handleTemplateSelect(e) {
    this.onTemplateSelect.emit(e);
  }
  sidebarClose(event) {
    this.closeSidebar.emit(true)
  }

  handleChargeChange(e) {
    this.onChargeChange.emit(e);
  }
  handleChargeandICDChange(e) {
    this.onChargeAndICDChange.emit(e);
  }
  handleNoteEditorIcdsChange($event){
    this.onNoteEdiorIcdsChange.emit($event)
  }
  async addCharge() {
    await this.sidebarChargesComponent.addCharge();
  }
  async addICD(icd) {
    this.sidebarChargesComponent.addICD(icd);
  }
  handleICDsSave(icds) {
    console.log('note-sidebar > handleICDsSave')
    this.onICDsSave.emit(icds);
  }
  getwoundCountState() {
    return new Promise<void>((resolve, reject) => {
      this._woundCareService.getAllWoundsParentStatesCount(this.patientId).subscribe((res: any) => {
        if (res.status === 200) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i]._id == 'active') {
              this.woundStateCounts.activeCount = res.data[i].count;
            }
            if (res.data[i]._id == 'remission') {
              this.woundStateCounts.remissionCount = res.data[i].count;
            }
            if (res.data[i]._id == 'amputated') {
              this.woundStateCounts.amputatedCount = res.data[i].count;
            }
            if (res.data[i]._id == 'archived') {
              this.woundStateCounts.archiveCount = res.data[i].count;
            }
          }
        }
        resolve();
      }, error => {
        reject('error => ' + error.toString());
      });
    });
  }

  watchHelpVideo( videoId ) {
    const dialogRef = this.dialog.open(WatchHelpVideoDialog, {
      data: { videoId }
    });

    dialogRef.afterClosed().subscribe( console.log );
  }
  // updatewoundDetailsfromNoteEdior(id, data){
  //   // this.skinwoundCareComponent.
  // }
  updateWoundfromNote(id, data){
    this.woundDermSidebar.updateWoundfromNote(id, data);
  }
  handlePhrasesChange($event) {
    this.onHtmlTextChanges.emit($event);
  }
  handleWoundDetailsChange($event){
    this.woundDetailsChange.emit($event);
  }
  handleNoteEditorCptsChange($event){
    this.onNoteEdiorCptsChange.emit($event)
  }
  submitButonClickedFun($event){
    this.submitButonClicked.emit(true);
  }
}
